<script setup lang="ts">
import type { PropertyStatusProps } from '.';

import { FilterChip } from '~/components/Filters/FilterChip';

import messages from './PropertyStatus.locale.json';

const strings = messages.pt;

defineProps<PropertyStatusProps>();

const isExclusive = defineModel<boolean>('modelValue');
</script>

<template>
	<div class="flex w-full flex-col gap-5 pt-5">
		<span
			class="font-matter-sq text-lg font-normal tracking-[-0.0225rem] text-primary"
		>
			{{ strings.title }}
		</span>

		<div class="flex w-full flex-wrap gap-2">
			<FilterChip v-model="isExclusive" :label="strings.labels.isExclusive" />
		</div>
	</div>
</template>
